import PartnerModuleSlice from "../slices/partnermodule.slice";
import InsurancetypeSlice from "../slices/Insurancetype.slice";
import insuranceFormSlice from "../slices/insuraneform.slice";
import WithdrawlSlice from "../slices/withdrawl.slice";
import DashboardSlice from "../slices/dashboard.slice";
import InsuranceSlice from "../slices/insurance.slice";
import DeliverySlice from "../slices/delivery.slice";
import ProfilesSlice from "../slices/profiles.slice";
import VechileTypeSlice from "../slices/type.slice";
import { combineReducers } from "@reduxjs/toolkit";
import PartnerSlice from "../slices/partner.slice";
import chargesSlice from '../slices/charges.slice';
import ServiceSlice from "../slices/service.slice";
import MessageSlice from "../slices/message.slice";
import EarningSlice from "../slices/earning.slice";
import SidebarSlice from "../slices/sidebarslice";
import CouponSlice from "../slices/coupon.slice";
import FilterSlice from "../slices/filter.slice";
import AdminSlice from "../slices/admin.slice";
import UsersSlice from "../slices/users.slice";
import otherSlice from "../slices/other.slice";
import EmailSlice from "../slices/email.slice";
import RideSlice from "../slices/rides.slice";
import AuthSlice from "../slices/auth.slice";
import PlanSlice from "../slices/plan.slice";
import RoleSlice from "../slices/role.slice";

const rootReducer = combineReducers({
  PlanSlice,
  RideSlice,
  AuthSlice,
  RoleSlice,
  EmailSlice,
  otherSlice,
  UsersSlice,
  AdminSlice,
  FilterSlice,
  CouponSlice,
  ServiceSlice,
  chargesSlice,
  PartnerSlice,
  MessageSlice,
  SidebarSlice,
  EarningSlice,
  ProfilesSlice,
  DeliverySlice,
  InsuranceSlice,
  WithdrawlSlice,
  DashboardSlice,
  VechileTypeSlice,
  insuranceFormSlice,
  PartnerModuleSlice,
  InsurancetypeSlice,
})

export default rootReducer